import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconChartBarComponent } from "./med-icon-chart-bar.component";

@NgModule({
  declarations: [
    MedIconChartBarComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconChartBarComponent,
  ],
})
export class MedIconChartBarModule { }
